const ClevertapClient = {
  initialize(accountId) {
    const clevertap = {
      event: [],
      profile: [],
      account: [],
      region: "in1",
      onUserLogin: [],
      notifications: [],
      privacy: [],
      spa: true,
    };
    clevertap.account.push({ id: accountId });
    clevertap.privacy.push({ optOut: false }); // set the flag to true, if the user of the device opts out of sharing their data
    clevertap.privacy.push({ useIP: false }); // set the flag to true, if the user agrees to share their IP data

    window.clevertap = clevertap;

    (function init() {
      const baseLink =
        window.location.protocol === "https:"
          ? "https://d2r1yp2w7bby2u.cloudfront.net"
          : "http://static.clevertap.com";
      const wzrk = document.createElement("script");
      wzrk.type = "text/javascript";
      wzrk.async = true;
      wzrk.src = baseLink + "/js/clevertap.min.js";
      const s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(wzrk, s);
    })();
  },

  event(name, payload) {
    if (payload) {
      window.clevertap?.event.push(name, payload);
    } else {
      window.clevertap?.event.push(name);
    }
  },

  profile(payload) {
    window.clevertap?.profile.push(payload);
  },

  onUserLogin(payload) {
    window.clevertap?.onUserLogin.push(payload);
  },

  logout() {
    window.clevertap?.logout();
  },
};

export default ClevertapClient;
